import React, { useState, useEffect } from 'react';
import Post from '../../../../utils/Post';
import VainillaDialog from '../../../sharecomponents/vanilladialog';
import { activeDialog } from '../../../../utils/Common';
import NuevoGradoDia from './Componentes/NuevoGradoDia';
import ListaGradosDias from './Componentes/ListaGradosDias';
import Verifiers from '../../../../utils/Verifiers.jsx';

const GradosDiasV2 = () => {
    const [dialog, setdialog] = useState({ show: false });
    const [loader, setloader] = useState(false);
    const ldr = (<div className='vw-100 vh-100 top-left-front bg-white3 blur-s'><div className='loader' /></div>);
    const [paginador, setpaginador] = useState({ page: 1, pages: 0, total: 0, per_page: 50, fecha_inicio: '', fecha_fin: '', user: '', soloCompletos: false, soloIncompletos: false, conGradosDia: false, estatus: 'activos' });
    const [data, setdata] = useState([]);
    const [users, setusers] = useState([]);
    const unselectClass = "btn btn-sm btn-light shadow round-xxl w-100 border border-warning"
    const selectClass = "btn btn-sm btn-white shadow-sm round-xxl w-100 border border-3 border-warning text-bold"

    var count = 0;

    useEffect(() => {
        getData();
    }, []);

    const keygen = () => {
        count++;
        return count;
    }

    const getApi = async (url, args) => {
        let resp = await Post(url, args, "POST", setloader);
        if (!resp.estatus) {
            activeDialog(setdialog, resp.msj, 'error', 'Error');
            return false;
        }
        return resp;
    }

    const getData = async (pg = { ...paginador }) => {
        let resp = await getApi('/api/general/gradosDias/get', pg);
        if (!resp) return;

        setdata(resp.data);
        setpaginador({ ...pg, pages: resp.pages, total: resp.total });
        setusers(resp.usuarios);
        Verifiers.scrollAnimacion('temp0');
    }

    const changeValue = (e) => {
        let { name, value } = e.target;
        let pg = { ...paginador, [name]: value };
        pg.page = 1;
        setpaginador(pg);
        getData(pg);
    }

    const aplicarFiltro = (e) => {
        let filtro = e.target.name;
        let pg = { ...paginador };
        pg[filtro] = !pg[filtro];
        pg.page = 1;
        setpaginador(pg);
        getData(pg);
    }

    const alternarEstado = () => {
        let estados = ['activos', 'cancelados', 'todos'];
        let pg = { ...paginador };
        let index = estados.indexOf(pg.estatus);
        index++;
        if (index >= estados.length) index = 0;
        pg.estatus = estados[index];
        pg.page = 1;
        setpaginador(pg);
        getData(pg);
    }

    const changePage = (back) => {
        let pg = { ...paginador };
        if (back) pg.page--;
        else pg.page++;
        getData(pg);
    }

    const jumpPage = (e) => {
        let pg = { ...paginador };
        pg.page = parseInt(e.target.value);
        getData(pg);
    }

    const paginas = () => {
        let paginas = [];
        for (let i = 0; i < paginador.pages; i++) paginas.push(i + 1);
        return paginas;
    }

    return (
        <div className='vw-100 p-2 overflow bg-white p-2 dosis dosis' style={{ height: "calc( 100vh - 60px)" }}>
            <div className='row justify-content-evenly w-100 m-0 p-0'>
                <div className='w-100 round-left-xxl gradient-small-black text-white text-300 p-1 ps-3 text-l'>
                    Registro de grados días
                </div>
                <div className='bw-200 contenedor m-1'>
                    <button className="btn btn-sm btn-dark text-l shadow text-bold w-100 border border-warning round-xxl" onClick={() => setpaginador({ ...paginador, nuevo: {} })}>Nuevo registro</button>
                </div>
                <div className='bw-150 m-1'>
                    <label className='text-bold w-100 text-center text-s'>Fecha inicial</label>
                    <input
                        type="date"
                        name='fecha_inicio'
                        className='form-control form-control-sm w-100 round-xxl shadow-sm border text-center'
                        value={paginador.fecha_inicio}
                        onChange={changeValue}
                    />

                </div>
                <div className='bw-150 m-1'>
                    <label className='text-bold w-100 text-center text-s'>Fecha fin</label>
                    <input
                        type="date"
                        name='fecha_fin'
                        className='form-control form-control-sm w-100 round-xxl shadow-sm border text-center'
                        value={paginador.fecha_fin}
                        onChange={changeValue}
                    />

                </div>
                <div className='bw-150 m-1'>
                    <label className='text-bold w-100 text-center text-s'>Usuario editor</label>
                    <select className='form-control form-control-sm w-100 round-xxl shadow-sm border text-center' name='user' value={paginador.user | ''} onChange={changeValue}>
                        <option value='' >Todos los usuarios</option>
                        {
                            users.map((user, i) => <option key={keygen()} value={user.id}>{user.nombre}</option>)
                        }
                    </select>
                </div>
                {[
                    { k: "soloCompletos", v: "Registros completos" },
                    { k: "sinEvotranspiracion", v: "Sin evapotranspiración" },
                    { k: "temperaturasCero", v: "Temperaturas en cero" }].map((key, index) =>
                        <div key={keygen()} className='bw-150 contenedor m-1'>
                            <button className={paginador[key.k] ? selectClass : unselectClass} name={key.k} onClick={aplicarFiltro}>{key.v}</button>
                        </div>
                    )}
                <div className='bw-150 contenedor m-1'>
                    <button className={selectClass} onClick={alternarEstado}>{paginador.estatus.toUpperCase()}</button>
                </div>

                <div className='form-group p-0 text-center bw-200 m-1 '>
                    <label className='text-bold text-xs w-100 p-0 m-0'>
                        <span className='text-xs p-0 m-0'>Página:</span> ({paginador.page} / {paginador.pages})
                        <span className='ms-2 text-xs p-0 m-0'>Registros:</span> {paginador.total}
                    </label>
                    <div className="btn-group w-100  p-0 m-0" role="group" >
                        <button type="button" className="w-30 btn btn-sm btn-dark round-left-xxl shadow-sm text-white"
                            disabled={paginador.page <= 1}
                            onClick={() => { changePage(true) }}>❮</button>
                        <select className='form-control form-control-sm text-center border w-40 p-0 m-0' value={paginador.page} onChange={jumpPage}>
                            {
                                (paginas() ?? []).map((pag, i) => {
                                    return (
                                        <option value={pag} key={i + "pagina" + pag} className='ps-3 pe-3'>{pag}</option>
                                    )
                                })
                            }
                        </select>
                        <button type="button" className="w-30 btn btn-sm btn-dark round-right-xxl shadow-sm text-white"
                            disabled={paginador.page >= paginador.pages}
                            onClick={() => { changePage(false) }}>❯</button>
                    </div>
                </div>
                <div className='w-100 mt-2 p-0' />
                <ListaGradosDias data={data} enviarElementoAPadre={(elemento) => setpaginador({ ...paginador, ['nuevo']: elemento })} />
            </div>
            <VainillaDialog dialog={dialog} />
            {paginador.nuevo && <NuevoGradoDia data={paginador.nuevo} close={(e) => { if (e) getData({ ...paginador, nuevo: false }); setpaginador({ ...paginador, nuevo: false }) }} />}
            {loader && ldr}
        </div>
    )
}

export default GradosDiasV2;